import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import util from './util.js';
import config from './config.js';
import CryptoJS from 'crypto-js'
// axios.defaults.baseURL = API_URL;
// axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;
 axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers['Access-Control-Allow-0rigin'] = '*';
//axios.defaults.headers['Access-Control-Allow-Headers'] = 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild';
function Client(api_url,img_url,order_url) {
    this.API_URL = api_url;
    this.IMG_URL = img_url;
    this.ORDER_URL = order_url;
    //GET请求方式
    this.get = function(action, params, callback, failback, auth) {
        this.ajax('get', action, params, callback, failback, auth);
    };

    //POST请求方式
    this.post = function(action, params, callback, failback, auth) {
        this.ajax('post', action, params, callback, failback, auth);
    };

    //请求前参数处理
    this.ajax = function(method, action, params, callback, failback, auth) {
		var is_params_str = false;

        //判断请求地址是否为空
        if (typeof action != 'string' || action == '') {
            //console.log('请求地址不能为空');
            return;
        }

        //判断params是否function，是则赋值给callback并设置params为null
        if (typeof params === 'function') {
            if (callback === 'auth') {
                auth = 'auth';
            }
            callback = params;
            params = null;
        } else if (typeof params === 'string') {
				is_params_str = true;
				
        }
		//console.log(params,"参数")
        //判断params是否为null，是则设置为空对象
        if (params === null) {
            params = {};
        }
        var options = {};
        options.method = method;
        //options.headers = {"language": "zh" };
        // options.url = action;
        options.url = api_url + action;
        options.timeout = 15000;
        // 判断是否需要验证授权，是则自动加上授权参数
		// if (!auth) {
            var token = localStorage.getItem('token') || '';
            var user_id = localStorage.getItem('user_id') || '';
            var timestamp=new Date().getTime();
            //console.log(token+user_id+timestamp);
            var md5Str = CryptoJS.MD5(token+user_id+timestamp);
            options.headers = {
            token: token,
			loginFrom:'pc',
            // sign:md5Str,
            timestamp:timestamp,
			
            };//添加请求头
        // }

        if (method == 'get') {
            options.params = params;
        } else {
            //options.data = qs.stringify(params);
				if (is_params_str) {
					options.data = params;
				} else if (!(typeof params == 'object' && params instanceof FormData)) {
                   // options.data = qs.stringify(params);原来的
				    options.data = params;
                } else {
                    options.data = params;
                }
        }
        setTimeout(function() {
            axios(options).then(function(response) {
                if (response.data.code == 200) {
                    if(typeof callback === 'function'){
						if(response.data.total || response.data.totalPages){
							callback(response.data.data, response.data.msg,response.data.total,response.data.totalPages);
						}else{
							callback(response.data.data, response.data.msg);
						}
                        
                    }
                    return;
                } else if (response.data.code === 500) {
                    Message(response.data.msg);
                    failback(response.data.msg);
                    return;
                }else if (response.data.code === 401) {
                    Message('登录失效，请重新登录再操作！');
                    localStorage.setItem('token','');
                    setTimeout(function(){
                        util.goTo('/login');
                    },1000);
                    return;
                } else {
                    if(typeof failback === 'function'){
                        failback(response.data.msg);
                    }
                    return;
                }
            }).catch(function(error) {
                if (error.response) {
                    if(typeof error.response == 'string'){
                        Message(error.response);
                    }
                    if(typeof failback === 'function'){
                        failback(error.response);
                    }
                    return;
                } else {
                    // Message('网络错误');
                    if(typeof failback === 'function'){
                        failback();
                    }
                    return;
                }
            });

        }, 0);
    };

}
var client = new Client(config.api_url,config.img_url,config.order_url);
export {client};
